export class GrsDashboard {
    from_date: string;
    id: string;
    to_date: string;
}

export class GRSComplaintDetails {
    response: string;
    closed: number;
    open: number;
    pending: number;
    reopen: number;
    resolved: number;
    total: number;
}

export class GRSDisputeDetails {
    response: string;
    closed: number;
    open: number;
    pending: number;
    reopen: number;
    resolved: number;
    total: number;
}

export class GRSTicketDetails {
    response: string;
    closed: number;
    open: number;
    pending: number;
    reopen: number;
    resolved: number;
    total: number;
}

export class ModeWiseComplain {
    from_date: string;
    id:string;
    to_date: string;
}

export class ModeWiseComplainView {
    mode_name: string[];
    mode_count: number[];
}

export class AgentPerformanceReportData {
    end_date: string;
    mode: string;
    start_date: string;
    user_id: string;
}


export class AgentPerformanceReport {
    agent_id: string;
    agent_user_name: string;
    total_login_time: string;
    close_comps: number;
    open_comps: number;
    pending_comps: number;
    reopen_comps: number;
    resolved_comps: number;
    total_comp_assign: number;
}

export class AgentPerformanceReportView {
    response: string;
    agent_performance_report: AgentPerformanceReport[];
}

// -----------------TAT-----------------------------
export class ComplaintTatMatrix {
    agnet_name: string;
    complaints_closed_in_tat: number;
    complaints_not_closed_in_tat: number;
    count: number;
}

export class TatComplaintView {
    complaint_tat_matrix: ComplaintTatMatrix[];
    reason: string;
    response: string;
}

export class TatComplaintData {
    from_date: string;
    id: string;
    to_date: string;
}


// WEBPACK FOOTER //
// ./src/app/dashboards/grs-admin-dashboard/grs-view.ts